import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { CpuModelInterface } from 'src/app/util/interfaces/cpuModel';

@Injectable({
	providedIn: 'root',
})
export class CpuModelService {
	private getCpuModelsURL = environment.baseApiUrl + 'register/cpuModel';
	private postCpuModelURL = environment.baseApiUrl + 'register/cpuModel';
	private putCpuModelURL = environment.baseApiUrl + 'register/cpuModel/{id}';
	private deleteCpuModelURL = environment.baseApiUrl + 'register/cpuModel';

	constructor(
		private httpClient: HttpClient,
		private authLoginService: AuthLoginService
	) {}

	private getHeaders(): HttpHeaders {
		return new HttpHeaders({
			Authorization: 'Bearer ' + this.authLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
	}

	getCpuModels(): Observable<CpuModelInterface[]> {
		return this.httpClient.get<CpuModelInterface[]>(this.getCpuModelsURL, { headers: this.getHeaders() });
	}

	postCpuModel(data: CpuModelInterface): Observable<any> {
		const body = {
			cpu: data.cpu,
			ci_type: data.ci_type,
		};

		return this.httpClient.post(this.postCpuModelURL, body, { headers: this.getHeaders() });
	}

	putCpuModel(data: CpuModelInterface): Observable<any> {
		const putCpuModelURL = this.putCpuModelURL.replace('{id}', data.id!.toString());
		const body = {
			cpu: data.cpu,
			ci_type: data.ci_type,
		};

		return this.httpClient.put(putCpuModelURL, body, { headers: this.getHeaders() });
	}

	deleteCpuModels(ids: number[]): Observable<any> {
		return this.httpClient.delete(this.deleteCpuModelURL, {
			headers: this.getHeaders(),
			body: JSON.stringify({ ids }),
		});
	}
}
